import {listener} from "../../../../../modules/vegas/js/util";
import axios from "axios";

function formButtonState(form, state) {
	let button = form.querySelector('button[type="submit"]');

	if (state === 'sending') {
		button.dataset.text = button.innerText;
		button.innerText = button.dataset.textLoading;
		button.setAttribute('disabled', true);
	}

	if (state === 'reset') {
		button.removeAttribute('disabled');
		button.innerText = button.dataset.text;
	}
}

function formError(form, data = null) {
	let err = form.querySelector('.error');
	err?.classList.add('d-none');

	if (data && data.error) {
		err.innerText = data.msg || 'Произошла неизвестная ошибка';
		err?.classList.remove('d-none');
	}
}

// отправка кода на старый номер
function listenSubmitGetCodeOld(form, nextForm) {
	listener('submit', `#${form.id}`, (form, e) => {
		formButtonState(form, 'sending');
		formError(form);

		axios.post(form.action, new FormData(form))
			.then(response => {
				if (response.data.error) {
					return formError(form, response.data);
				}

				form.classList.add('d-none');
				nextForm.classList.remove('d-none');
			})
			.finally(() => {
				formButtonState(form, 'reset');
			})
		;
	}, true);
}


// подтверждение кода старого номера
function listenSubmitCodeOld(form, nextForm) {
	listener('submit', `#${form.id}`, (form, e) => {
		formButtonState(form, 'sending');
		formError(form);

		axios.post(form.action, new FormData(form))
			.then(response => {
				if (response.data.error) {
					return formError(form, response.data);
				}

				nextForm.classList.remove('d-none');
				form.classList.add('disabled');
			})
			.finally(() => {
				formButtonState(form, 'reset');
			})
		;
	}, true);
}


// отправка кода на новый номер
function listenSubmitGetCodeNew(form, nextForm) {
	listener('submit', `#${form.id}`, (form, e) => {
		formButtonState(form, 'sending');
		formError(form);

		axios.post(form.action, new FormData(form))
			.then(response => {
				if (response.data.error) {
					return formError(form, response.data);
				}

				form.classList.add('disabled');
				nextForm.classList.remove('d-none');
			})
			.catch(result => {
				formError(form, result.response.data);
			})
			.finally(() => {
				formButtonState(form, 'reset');
			})
		;
	}, true);
}

function listenSubmitCodeNew(form) {
	listener('submit',`#${form.id}`, (form, e) => {
		formButtonState(form, 'sending');
		formError(form);

		let formData = new FormData(form);

		axios.post(form.action, formData)
			.then(response => {
				if (response.data.error) {
					return formError(form, response.data);
				}

				form.classList.add('disabled');

				location.reload();
			})
			.finally(() => {
				formButtonState(form, 'reset');
			})
		;
	}, true);
}

let modalChangePhone = document.getElementById('modal-change-phone');
let modalChangePhoneFormGetCodeOld = modalChangePhone?.querySelector('#form-change-phone-get-code-old');
let modalChangePhoneFormSubmitCodeOld = modalChangePhone?.querySelector('#form-change-phone-submit-code-old');
let modalChangePhoneFormGetCodeNew = modalChangePhone?.querySelector('#form-change-phone-get-code-new');
let modalChangePhoneFormSubmitCodeNew = modalChangePhone?.querySelector('#form-change-phone-submit-code-new');

modalChangePhoneFormGetCodeOld && listenSubmitGetCodeOld(modalChangePhoneFormGetCodeOld, modalChangePhoneFormSubmitCodeOld);
modalChangePhoneFormSubmitCodeOld && listenSubmitCodeOld(modalChangePhoneFormSubmitCodeOld, modalChangePhoneFormGetCodeNew);
modalChangePhoneFormGetCodeNew && listenSubmitGetCodeNew(modalChangePhoneFormGetCodeNew, modalChangePhoneFormSubmitCodeNew);
modalChangePhoneFormSubmitCodeNew && listenSubmitCodeNew(modalChangePhoneFormSubmitCodeNew);

let modalChangeEmail = document.getElementById('modal-change-email');
let modalChangeEmailFormGetCodeOld = modalChangeEmail?.querySelector('#form-change-email-get-code-old');
let modalChangeEmailFormSubmitCodeOld = modalChangeEmail?.querySelector('#form-change-email-submit-code-old');
let modalChangeEmailFormGetCodeNew = modalChangeEmail?.querySelector('#form-change-email-get-code-new');
let modalChangeEmailFormSubmitCodeNew = modalChangeEmail?.querySelector('#form-change-email-submit-code-new');

modalChangeEmailFormGetCodeOld && listenSubmitGetCodeOld(modalChangeEmailFormGetCodeOld, modalChangeEmailFormSubmitCodeOld);
modalChangeEmailFormSubmitCodeOld && listenSubmitCodeOld(modalChangeEmailFormSubmitCodeOld, modalChangeEmailFormGetCodeNew);
modalChangeEmailFormGetCodeNew && listenSubmitGetCodeNew(modalChangeEmailFormGetCodeNew, modalChangeEmailFormSubmitCodeNew);
modalChangeEmailFormSubmitCodeNew && listenSubmitCodeNew(modalChangeEmailFormSubmitCodeNew);
